import React from 'react';
import styled from 'styled-components';
import { LoadingIndicator } from '@spotify-internal/encore-web';
const Backdrop = styled.div `
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Wait = () => {
    return (React.createElement(Backdrop, { "data-testid": "waiting" },
        React.createElement(LoadingIndicator, null)));
};
//# sourceMappingURL=Wait.js.map